module.exports = __webpack_public_path__ + "img/code_mao.4f80dd81.png";